module.exports = __webpack_public_path__ + "img/prizeBtnIng.07d4430b.png";